// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5645":"a9291050","6429":"17b45fdb","8137":"a9291050"}[chunkId] + ".chunk.css";
};